module.exports = __webpack_public_path__ + "img/车辆监控.b358c2bc.png";